// extracted by mini-css-extract-plugin
module.exports = {"navHeight":"4.5rem","table-bg":"buyCredits_table-bg__1tBy-","credit1":"buyCredits_credit1__GDxxo","active":"buyCredits_active__3q5xH","credit-btn":"buyCredits_credit-btn__2vpDs"};